import React from 'react';
import { FaHeart, FaShoppingBag } from 'react-icons/fa';
import "./Favorite.css";
import Loader from '../../components/Loader.js';
import ProductCard from '../../components/product/ProductCard.js';
import { useGetFavoritesQuery, useRemoveFromFavoriteMutation } from '../../services/favoriteApi';

const Favorite = () => {
    // FavoriteContext yerine doğrudan RTK Query hook'larını kullanıyoruz
    const { data: favorites = [], isLoading: loading } = useGetFavoritesQuery();
    const [removeFromFavorite] = useRemoveFromFavoriteMutation();

    const handleRemoveFavorite = async (event, product) => {
        event.stopPropagation();
        event.preventDefault();
        
        try {
            await removeFromFavorite(product.favorite_id).unwrap();
            // İşlem başarılı olduğunda otomatik olarak önbellek güncellenir
        } catch (error) {
            console.error('Favori kaldırma işlemi sırasında hata:', error);
        }
    };

    // Her ürün favori olduğu için true döndür
    const isFavorite = () => true;

    if (loading) return <Loader />;
    
    return (
        <div className='favorites'>
            {favorites.length === 0 ? (
                <div className="empty-favorites mt-5">
                    <div className="empty-favorites-icon">
                        <FaHeart size={60} />
                    </div>
                    <p>Favori ürün bulunmamaktadır.</p>
                    <p className="empty-favorites-message">Beğendiğiniz ürünleri favorilerinize ekleyerek daha sonra kolayca ulaşabilirsiniz.</p>
                    <a href="/" className="shop-now-button">
                        <FaShoppingBag style={{ marginRight: '8px' }} />
                        Alışverişe Başla
                    </a>
                </div>
            ) : (
                <div className="favori-container">
                    <div className='favorite-title'>
                        <h2 className='mt-md-2 mt-0'>
                            <FaHeart style={{ marginRight: '5px', color: 'red' }} />
                            Favorilerim
                        </h2>
                    </div>
                    <div className="favori-grid">
                        {favorites.map(product => (
                            <ProductCard
                                key={product.sef}
                                product={product}
                                isFavorite={isFavorite}
                                onFavoriteToggle={handleRemoveFavorite}
                                showGramPrice={true}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Favorite;